export default "__VITE_ASSET__Cq2U6LsP__"